module.exports = __webpack_public_path__ + "img/DGJLogo.e125b914.png";